import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { Btn, H1, Image, P } from '../../../../AbstractElements';
import { dynamicImage, dynamicNumber } from '../../../../Utils';
import { Href } from '../../../../Utils/Constants';
import DashboardSvgIcon from '../../../../Utils/CommonComponents/DashboardSvgIcon';
import dayjs from 'dayjs'; // You can also use native JS if you prefer

export default function WelcomeBanner() {
  const [currentTime, setCurrentTime] = useState(dayjs().format('hh:mm A'));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(dayjs().format('hh:mm A'));
    }, 1000); // update every second

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Col xxl={4} xl={5} lg={5} md={5} sm={12} >
      <Card className="welcome-banner">
        <CardHeader className="p-0 card-no-border">
          <div className="welcome-card">
            <Image className="w-100 img-fluid" src={dynamicImage(`dashboard-1/welcome-bg.png`)} alt="" />
            {dynamicNumber(5).map((item, index) => (
              <Image key={index} className={`position-absolute img-${item} img-fluid`} src={dynamicImage(`dashboard-1/img-${item}.png`)} alt="" />
            ))}
          </div>
        </CardHeader>
        <CardBody>
          <div className="d-flex align-center">
            <H1>{'Hello, Admin'}
              <Image src={dynamicImage(`dashboard-1/hand.png`)} alt="" />
            </H1>
          </div>
          <P>{'Welcome back! Let’s start from where you left.'}</P>
          <div className="d-flex align-center justify-content-between">
            {/* <Btn color='primary' className="btn-pill" href={Href}>{'Whats New!'}</Btn> */}
            <span>
              <DashboardSvgIcon className='stroke-icon' iconId='watch' />
              {' ' + currentTime}
            </span>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}






// import React from 'react'
// import { Card, CardBody, CardHeader, Col } from 'reactstrap'
// import { Btn, H1, Image, P } from '../../../../AbstractElements'
// import { dynamicImage, dynamicNumber } from '../../../../Utils'
// import { Href } from '../../../../Utils/Constants'
// import DashboardSvgIcon from '../../../../Utils/CommonComponents/DashboardSvgIcon'

// export default function WelcomeBanner() {
//     return (
//         <Col xl={4} sm={6} className="proorder-xxl-1 box-col-6">
//             <Card className="welcome-banner">
//                 <CardHeader className="p-0 card-no-border">
//                     <div className="welcome-card">
//                         <Image className="w-100 img-fluid" src={dynamicImage(`dashboard-1/welcome-bg.png`)} alt="" />
//                         {dynamicNumber(5).map((item, index) => (
//                             <Image key={index} className={`position-absolute img-${item} img-fluid`} src={dynamicImage(`dashboard-1/img-${item}.png`)} alt="" />
//                         ))}
//                     </div>
//                 </CardHeader>
//                 <CardBody>
//                     <div className="d-flex align-center">
//                         <H1>{'Hello, Amirreza '}
//                             <Image src={dynamicImage(`dashboard-1/hand.png`)} alt="" />
//                         </H1>
//                     </div>
//                     <P> {'Welcome back! Let’s start from where you left.'}</P>
//                     <div className="d-flex align-center justify-content-between">
//                         <Btn color='primary' className="btn-pill" href={Href}>{'Whats New!'}</Btn>
//                         <span>
//                             <DashboardSvgIcon className='stroke-icon' iconId='watch' />
//                             {' 11:14 AM'}
//                         </span>
//                     </div>
//                 </CardBody>
//             </Card>
//         </Col>
//     )
// }